<script lang="ts" setup>
import i18n from '@/helper/Translations'
import { ModalTypes } from '@/helper/ModalTypes'
import { modalService } from '@/services/modals/ModalService'
import ModalParams from '@/services/modals/ModalParams'
import { ref } from 'vue'
import DOMPurify from 'dompurify'

const props = defineProps<{
  translationKey?: string
  modalType?: ModalTypes,
  modalPayload?: any
}>()

const helpText = ref('')

if (props.translationKey && !props.modalType) {
  const helpKey = props.translationKey + '_help'
  if (i18n.global.te(helpKey)) {
    const translatedHelpText = i18n.global.t(helpKey)

    if (!translatedHelpText.startsWith('~')) {
      helpText.value = DOMPurify.sanitize(translatedHelpText, { ALLOWED_TAGS: ['br'] })
    }
  }
}

function openHelpModal() {
  const payload = {
    modalText: helpText.value,
    modalTitle: props.translationKey ? i18n.global.t(props.translationKey) : '',
    ...props.modalPayload
  }

  const modalType = props.modalType ? props.modalType : ModalTypes.HELP
  const modalParams = new ModalParams(modalType, payload)

  modalService.showModal(modalParams)
}
</script>

<template>
  <button
    v-if="helpText || props.modalType"
    :title="$t('step_heating_details.help')"
    class="btn is--raw icon-text is--info"
    type="button"
    @click="openHelpModal"
    @mousedown="openHelpModal"
  >
    <i class="ic-info-circle" />
  </button>
</template>

<style lang="scss" scoped>
span {
  font-size: inherit;
  line-height: inherit;
}

.is--info i.ic-info-circle {
  margin-left: 0;
}
</style>
